var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workflow-disclaimer"},[_c('p',{staticClass:"body-1"},[_c('base-icon',{staticClass:"info-icon",attrs:{"icon-name":"info"}}),_vm._v(" "),_vm._v(" "+_vm._s(_vm.$t('message.workflowDisclaimer'))+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }